import { useSelector } from "react-redux";

export function useIsCeremonyMaster(ceremonyId: number) {
    const ceremonyMaster = useSelector((state) => state.entities.ceremonies.byId[ceremonyId].item.ceremonyMaster);
    const user = useSelector((state) => state.user.profile);

    return ceremonyMaster.id === user.id;
}
